import {UI} from "../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../stem-core/src/ui/Style";
import {WidgetClose} from "../SVGElements";
import {Router} from "../../stem-core/src/ui/Router";
import {WidgetRoutes} from "./WidgetRoutes";
import {styleRule} from "../../stem-core/src/decorators/Style";
import {registerStyle} from "../../stem-core/src/ui/style/Theme";
import {collapseIframe} from "./misc/WidgetUtils";
import {POPUP_GATE_TRANSITION} from "../../blink-sdk/Constants";


export class WidgetCloseButtonStyle extends StyleSheet {
    @styleRule
    closeButton = {
        position: "absolute",
        zIndex: 999999,
        right: 8,
        top: 4,
        opacity: 0,
        padding: 10,
        pointerEvents: "none",
        transition: POPUP_GATE_TRANSITION,
        " path": {
            transition: POPUP_GATE_TRANSITION,
        },
    };

    @styleRule
    light = {
        " g": {
            fill: this.themeProps.WHITE,
        }
    };

    @styleRule
    visible = {
        opacity: "1 !important",
        pointerEvents: "all !important",
        cursor: "pointer",
    };
}

@registerStyle(WidgetCloseButtonStyle)
export class WidgetCloseButton extends WidgetClose {
    visible = false;
    lightTheme = true;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            color: this.styleSheet.themeProps.MERCHANT_FRAME_CLOSE_BUTTON_COLOR,
        };
    }

    widgetRoutes = [
        WidgetRoutes.ADD_FUNDS,
        WidgetRoutes.ADD_CARD,
        WidgetRoutes.CHOOSE_CARD,
        WidgetRoutes.WELCOME,
        WidgetRoutes.INSUFFICIENT_FUNDS,
    ];

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.closeButton);
        if (this.visible) {
            attr.addClass(this.styleSheet.visible);
        }
        if (!this.lightTheme) {
            attr.addClass(this.styleSheet.light);
        }
    }

    onMount() {
        super.onMount();
        // Note: Changing the route won't cut it, cause we need the popup panel logic to also clear itself in case we are in a popup.
        this.addClickListener(collapseIframe);
        const handleRouteVisibility = url => {
            this.visible = url !== "/" + WidgetRoutes.INDEX_COLLAPSED;
            this.lightTheme = this.widgetRoutes.indexOf(url) === -1;
            this.redraw();
        };

        this.attachTimeout(() => handleRouteVisibility(Router.getCurrentPath()));
        this.attachListener(Router.Global, "change", handleRouteVisibility);
    }
}
